import type { OrganizationUser } from "@kontextwerk/control-web-client"
import { userDisplayName } from "@kontextwerk/control-web-frame/logic/userDisplay"
import { buildWorkingHoursByUser } from "../../../../../../../../../_shared/_logic/working-hours-view"
import { filterSelectableOrganizationUsers } from "../../../../../../../_shared/_logic/organization-users"
import type {
  EmployeeOption,
  WorkingHoursByUser,
} from "../../../../../../../../../_shared/_logic/form-state"

export type BatchPlanningEmployeeContext = {
  employees: EmployeeOption[]
  workingHoursByUser: WorkingHoursByUser
  allEmployeeIds: string[]
}

export const buildBatchPlanningEmployeeContext = (
  users: OrganizationUser[] | null | undefined,
  allowedEmployeeIds: string[] | null | undefined,
): BatchPlanningEmployeeContext => {
  const scopedUsers = filterSelectableOrganizationUsers(users ?? [], allowedEmployeeIds)

  return {
    employees: scopedUsers.map((user) => ({
      id: user.id,
      label: userDisplayName(user) || "Unbekannt",
    })),
    workingHoursByUser: buildWorkingHoursByUser(scopedUsers),
    allEmployeeIds: scopedUsers.map((user) => user.id).filter(Boolean),
  }
}
